import React from "react";

function NotFound(props) {
  return (
    <div
      className="notFound"
      style={{
        height: "40rem",
        lineHeight: "40rem",
        textAlign: "center",
        fontSize: "2rem",
        fontWeight: "bold",
      }}
    >
      잘못된 접근입니다.
    </div>
  );
}

export default NotFound;
